import {
  TEMPLATES_WIZARD_STEP,
  SAVE_TEMPLATES_WIZARD_DATA,
  SHOW_CONNECT_DOMAIN_MODAL,
  SAVE_CONNECT_DOMAIN_DATA,
  SAVE_OPTION_STATE_INSTALLURL,
  SAVE_TEMPLATE_THEME_DATA,
  SAVE_OPTION_STATE_PUBLISH,
  SHOW_CONFIRM_MODAL,
  SAVE_SELECTED_PLAN,
  SAVE_OPTION_STATE_THEME,
  WEBSITE_MODULE_CONTENT,
  SITE_DETAILS,
  SAVE_OPTION_STATE_DOMAINS,
  SAVE_OPTION_STATE_UPGRADE,
  TEMPLATE_MODULEPATH,
  REDEPLOY,
  INITIAL_CHECK_AT_THEME,
  TEMPLATE_IMAGEPATH,
  WEBSITE_PAGES,
  EVENT_WEBSITE_PAGES_VALUES,
  WEBSITE_HEADERFOOTER,
  DEPLOY_RESPONSE,
} from "../actions";

export function TemplatesWizardStep(state = {}, action) {
  switch (action.type) {
    case TEMPLATES_WIZARD_STEP:
      return action.payload;
    default:
      return state;
  }
}

export function TemplatesWizardData(state = {}, action) {
  switch (action.type) {
    case SAVE_TEMPLATES_WIZARD_DATA:
      return action.payload;
    default:
      return state;
  }
}

export function connectDomainModal(state = {}, action) {
  switch (action.type) {
    case SHOW_CONNECT_DOMAIN_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function connectDomainData(state = {}, action) {
  switch (action.type) {
    case SAVE_CONNECT_DOMAIN_DATA:
      return action.payload;
    default:
      return state;
  }
}

export function optionStateInstallURL(state = {}, action) {
  switch (action.type) {
    case SAVE_OPTION_STATE_INSTALLURL:
      return action.payload;
    default:
      return state;
  }
}

export function templateThemeData(state = {}, action) {
  switch (action.type) {
    case SAVE_TEMPLATE_THEME_DATA:
      return action.payload;
    default:
      return state;
  }
}

export function optionStatePublish(state = {}, action) {
  switch (action.type) {
    case SAVE_OPTION_STATE_PUBLISH:
      return action.payload;
    default:
      return state;
  }
}

export function confirmModal(state = {}, action) {
  switch (action.type) {
    case SHOW_CONFIRM_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function selectedPlan(state = {}, action) {
  switch (action.type) {
    case SAVE_SELECTED_PLAN:
      return action.payload;
    default:
      return state;
  }
}

export function optionStateTheme(state = {}, action) {
  switch (action.type) {
    case SAVE_OPTION_STATE_THEME:
      return action.payload;
    default:
      return state;
  }
}

export function deployWebsiteResponse(state = {}, action) {
  switch (action.type) {
    case DEPLOY_RESPONSE:
      return action.payload;
    default:
      return state;
  }
}

export function websiteModule(state = {}, action) {
  switch (action.type) {
    case WEBSITE_MODULE_CONTENT:
      return action.payload;
    default:
      return state;
  }
}

export function siteDetails(state = {}, action) {
  switch (action.type) {
    case SITE_DETAILS:
      return action.payload;
    default:
      return state;
  }
}

export function optionStateDomains(state = {}, action) {
  switch (action.type) {
    case SAVE_OPTION_STATE_DOMAINS:
      return action.payload;
    default:
      return state;
  }
}

export function optionStateUpgrade(state = {}, action) {
  switch (action.type) {
    case SAVE_OPTION_STATE_UPGRADE:
      return action.payload;
    default:
      return state;
  }
}

export function templateModulepath(state = {}, action) {
  switch (action.type) {
    case TEMPLATE_MODULEPATH:
      return action.payload;
    default:
      return state;
  }
}

export function redeploy(state = {}, action) {
  switch (action.type) {
    case REDEPLOY:
      return action.payload;
    default:
      return state;
  }
}

export function initialCheckAtTheme(state = {}, action) {
  switch (action.type) {
    case INITIAL_CHECK_AT_THEME:
      return action.payload;
    default:
      return state;
  }
}

export function templateImagepath(state = {}, action) {
  switch (action.type) {
    case TEMPLATE_IMAGEPATH:
      return action.payload;
    default:
      return state;
  }
}

export function websitePages(state = {}, action) {
  switch (action.type) {
    case WEBSITE_PAGES:
      return action.payload;
    default:
      return state;
  }
}
export function titleUrl(state = {}, action) {
  switch (action.type) {
    case EVENT_WEBSITE_PAGES_VALUES:
      return action.payload;
    default:
      return state;
  }
}
export function headerFooter(state = {}, action) {
  switch (action.type) {
    case WEBSITE_HEADERFOOTER:
      return action.payload;
    default:
      return state;
  }
}
